import Vue from 'vue/dist/vue.esm';
import SingleSelectorModal from '../../core/itemselector/singleitemselectormodal';
import Grid from './dossieritemselectorgrid';

export default Vue.component('pageselectormodal', {
    extends: SingleSelectorModal,
    components: {
        'grid': Grid
    }
});